










import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { QueryUserPointsRecordList } from '@/api'
import constant from '@/utils/constant'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { PointsRecordStatusFormat } from '@/utils/tyepconvert'
import { DateFormat } from '@/utils/date/DateUtil'

@Component({
  components: {
    VQuery,
    VTable,
  },
})
export default class UserPointsRecordDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    this.show = false
    this.queryParam = {
      startRow: 1,
      limit: 10,
      orderBy: 'create_time desc , id desc',
      recordNo: undefined,
      userId: undefined,
      createTimeDaterange: [],
      finishTimeDaterange: [],
    }
  }

  private data: any = {}
  private show = false

  public open(data: any) {
    this.show = true
    this.data = data || {}
    if (this.data.userId) {
      this.queryParam.userId = this.data.userId
    }
    if (this.data.recordNo) {
      this.queryParam.recordNo = this.data.recordNo
    }
    this.loadData()
  }

  private queryParam: any = {
    startRow: 1,
    limit: 10,
    orderBy: 'create_time desc , id desc',
    recordNo: undefined,
    userId: undefined,
    createTimeDaterange: [],
    finishTimeDaterange: [],
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  private queryModels: Array<QueryModel> = [
    { title: '关联单号', param: 'recordNo' },
    { title: '途径类型', param: 'wayType', type: 'select', selectData: constant.FrozenPointsWayType },
    { title: '状态', param: 'status', type: 'select', selectData: constant.PointsRecordStatus },
    { title: '完成时间', param: 'finishTimeDaterange', type: 'daterange' },
    { title: '创建时间', param: 'createTimeDaterange', type: 'daterange' },
  ]

  private queryOperation: Array<TableOperation> = []

  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '变动数量', param: 'qty' },
    { title: '应变动', param: 'shouldQty' },
    { title: '关联单号', param: 'recordNo', width: 180, overflow: true },
    { title: '途径类型', param: 'wayTypeName', width: 200, overflow: true },
    { title: '状态', param: 'status', formatter: PointsRecordStatusFormat, width: 88 },
    { title: '变动前余额', param: 'beforeBalance' },
    { title: '变动后余额', param: 'balance' },
    { title: '完成时间', width: 160, param: 'finishTime', formatter: DateFormat },
    { title: '创建时间', width: 160, param: 'createTime', formatter: DateFormat },
    { title: '备注', param: 'note', overflow: true },
  ]

  public async loadData() {
    const param = this.getRequestParam()
    const result = await QueryUserPointsRecordList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  private getRequestParam() {
    const param: any = { ...this.queryParam }
    if (this.data.userId) {
      param.userId = this.data.userId
    }
    if (param.createTimeDaterange && param.createTimeDaterange.length > 0) {
      param.createTimes = DateFormat(param.createTimeDaterange[0]) + ',' + DateFormat(param.createTimeDaterange[1])
    }
    if (param.finishTimeDaterange && param.finishTimeDaterange.length > 0) {
      param.finishTimes = DateFormat(param.finishTimeDaterange[0]) + ',' + DateFormat(param.finishTimeDaterange[1])
    }
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 12)
    return param
  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }

  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
